import { Alert } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { ApiError } from "go-core/api/types";
import { selectOrganization } from "../../../../../../../../../services/organizations/selectors";

interface Props {
	errors: ApiError[];
}

const InvoiceValidationErrors = (props: Props) => {
	const { errors } = props;
	const codes = errors.map((error) => error.code);
	const { t } = useTranslation();
	const organization = useSelector(selectOrganization);

	if (!codes.includes("card_not_added") && !codes.includes("card_invalid")) return null;

	return (
		<Alert variant="danger">
			{errors.map((err) => {
				return (
					<>
						<Link to={`/${organization.id}/subscriptions`} target={"_blank"}>
							{t(`constraints.${err.code}`)}
						</Link>
					</>
				);
			})}
		</Alert>
	);
};
export default InvoiceValidationErrors;
